
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/payment-defaults",
      function () {
        return require("private-next-pages/payment-defaults/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/payment-defaults"])
      });
    }
  